// Studyo Today Backend
// Package studyo.today.users.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/users/v1/resources/preference_value.proto (package studyo.today.users.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/users/v1/resources/preference_value.proto.
 */
export const file_studyo_today_users_v1_resources_preference_value = /*@__PURE__*/
  fileDesc("CjZzdHVkeW8vdG9kYXkvdXNlcnMvdjEvcmVzb3VyY2VzL3ByZWZlcmVuY2VfdmFsdWUucHJvdG8SH3N0dWR5by50b2RheS51c2Vycy52MS5yZXNvdXJjZXMidQoPUHJlZmVyZW5jZVZhbHVlEhYKDHN0cmluZ192YWx1ZRgBIAEoCUgAEhQKCmJvb2xfdmFsdWUYAiABKAhIABITCglpbnRfdmFsdWUYAyABKAVIABIWCgxkb3VibGVfdmFsdWUYBCABKAFIAEIHCgV2YWx1ZUInqgIkU3R1ZHlvLlRvZGF5LlVzZXJzLkdycGMuVjEuUmVzb3VyY2VzYgZwcm90bzM");

/**
 * Describes the message studyo.today.users.v1.resources.PreferenceValue.
 * Use `create(PreferenceValueSchema)` to create a new message.
 */
export const PreferenceValueSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_users_v1_resources_preference_value, 0);

